import script from "./infos.vue?vue&type=script&setup=true&lang=ts"
export * from "./infos.vue?vue&type=script&setup=true&lang=ts"

import "./infos.vue?vue&type=style&index=0&id=de0fce28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de0fce28"]])

export default __exports__